/* Edit your JS here */
$(function() {
	
	//BEGIN
	$(".accordion__title").on("click", function(e) {

		e.preventDefault();
		var $this = $(this);

		if (!$this.hasClass("accordion-active")) {
			$(".accordion__content").slideUp(400);
			$(".accordion__title").removeClass("accordion-active");
			$('.accordion__arrow').removeClass('accordion__rotate');
		}

		$this.toggleClass("accordion-active");
		$this.next().slideToggle();
		$('.accordion__arrow',this).toggleClass('accordion__rotate');
	});
	//END
  
    $(".close_modal_popup").click(function(){
      $(".modal_popup").hide();
    });

    $(document).on('click',function(e){
      if(!(($(e.target).closest(".modal_popup .inner_modal_popup img").length > 0 ) || ($(e.target).closest(".modal_popup .inner_modal_popup img").length > 0))){
      $(".modal_popup").hide();
     }
    });
});